// File: noviopus-ats-client/src/components/Toastr/selectors.ts
import { createSelector } from 'reselect';
import { safeGet } from '@/utils/safeImmutable';

// Safe extraction from POJO root
// We use safeGet because the root is POJO, but 'toastr' slice might be Immutable
const selectToastr = (state: any) => safeGet(state, 'toastr');

export const getActiveToast = createSelector(
  [selectToastr],
  (substate) => {
    // Handle if substate is Immutable or POJO
    return safeGet(substate, 'activeToast');
  }
);

// FIX: Added missing getQueue selector
export const getQueue = createSelector(
  [selectToastr],
  (substate) => {
    return safeGet(substate, 'queue');
  }
);